import { useRef, useState, useEffect, memo } from 'react';
import { Sparkles } from '@react-three/drei';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';

interface HitEffectProps {
    id: string;
    active: boolean;
    position: [number, number, number];
    color: string;
    onComplete?: () => void;
}

export const HitEffect = memo(({ active, position, color, onComplete }: HitEffectProps) => {
    useEffect(() => {
        if (active) {
            const timer = setTimeout(() => {
                if (onComplete) onComplete();
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [active, onComplete]);

    const { camera } = useThree();
    const camPos = camera ? camera.position : new THREE.Vector3();
    const posVec = new THREE.Vector3(position[0], position[1], position[2]);
    const dist = camPos.distanceTo(posVec);

    return (
        <group position={position} visible={active}>
            {active && (
                <>
                    {/* High-intensity sparkles with glow create fake light effect via bloom */}
                    <Sparkles
                        count={Math.max(8, Math.floor(30 * Math.min(1, 50 / Math.max(1, dist))))}
                        scale={1.2}
                        size={5}
                        speed={0.7}
                        opacity={1}
                        color={color}
                    />
                </>
            )}
        </group>
    );
});
